export function ProvinceModel(dict) {
    this.provinceCode = dict.province_code 
        ? dict.province_code
        : dict.ProvinceCode;
    
    this.provinceName = dict.province_name
        ? dict.province_name
        : dict.ProvinceName;

    this.provinceNameEN = dict.ProvinceName_EN;
}

export function DistrictModel(dict) {
    this.districtCode = dict.district_code
        ? dict.district_code
        : dict.DistrictCode;

    this.districtName = dict.district_name
        ? dict.district_name
        : dict.DistrictName;

    this.districtNameEN = dict.district_name_EN
        ? dict.district_name_EN
        : dict.DistrictName_EN;

    this.provinceCode = dict.province_code
        ? dict.province_code
        : dict.ProvinceCode;
}

export function SubDistrictModel(dict) {
    this.subdistrictCode = dict.subdistrict_code
        ? dict.subdistrict_code
        : dict.SubDistrictCode;

    this.subdistrictName = dict.subdistrict_name
        ? dict.subdistrict_name
        : dict.SubDistrictName;

    this.provinceCode = dict.provinceCode
        ? dict.provinceCode
        : dict.ProvinceCode;

    this.districtCode = dict.districtCode
        ? dict.districtCode
        : dict.DistrictCode;

    this.subdistrictNameEN = dict.SubDistrictName_EN;
    this.city = dict.city;
    this.zipcode = dict.zip_code;
}

export function AddressModel() {
    this.strAddress = '';
    this.strProvinceCode = '';
    this.strProvinceName = '';
    this.strProvinceNameEn = '';
    this.strDistrictCode = '';
    this.strDistrictName = '';
    this.strDistrictNameEn = '';
    this.strSubDistrictCode = '';
    this.strSubDistrictName = '';
    this.strSubDistrictNameEn = '';
    this.strZipcode = '';

    this.getProvinceModel = function() {
        var province = new ProvinceModel({
            province_code: this.strProvinceCode,
            province_name: this.strProvinceName,
            ProvinceName_EN: this.strProvinceNameEn,
        });
        return province;
    };

    this.getDistrictModel = function () {
        var district = new DistrictModel({
            district_code: this.strDistrictCode,
            district_name: this.strDistrictName,
            district_name_EN: this.strDistrictNameEn,
            province_code: this.strProvinceCode,
        });
        return district;
    };

    this.getSubDistrictModel = function() {
        var subDistrict = new SubDistrictModel({
            subdistrict_code: this.strSubDistrictCode,
            subdistrict_name: this.strSubDistrictName,
            SubDistrictName_EN: this.strSubDistrictNameEn,
            districtCode: this.strDistrictNameEn,
            provinceCode: this.strProvinceName,
            zip_code: this.strZipcode,
        });
        return subDistrict;
    };

    this.getObject = function() {
        return {
            strAddress              :this.strAddress,
            strProvinceCode         :this.strProvinceCode,
            strProvinceName         :this.strProvinceName,
            strProvinceNameEn       :this.strProvinceNameEn,
            strDistrictCode         :this.strDistrictCode,
            strDistrictName         :this.strDistrictName,
            strDistrictNameEn       :this.strDistrictNameEn,
            strSubDistrictCode      :this.strSubDistrictCode,
            strSubDistrictName      :this.strSubDistrictName,
            strSubDistrictNameEn    :this.strSubDistrictNameEn,
            strZipcode              :this.strZipcode,
        };
    };
}
